export function htmlToPlainText(html: string): string {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent ?? div.innerText ?? "";
}

export function isHtmlEmpty(html: string): boolean {
  if (!html) {return true;}
  const text = htmlToPlainText(html).trim();
  return text.length === 0;
}
